import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import * as jose from 'jose';
import { LocalStorageService } from '../../shared/services/local-storage-service';
import { ACCESS_TOKEN_PORTAL_KEY } from '../constants/storage-keys';

function isJwtVigente(token: string): boolean {
  try {
    const { exp } = jose.decodeJwt(token);
    return exp !== undefined && exp * 1000 > Date.now();
  } catch {
    return false;
  }
}

export const requerimentoTokenGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const localStorageService = inject(LocalStorageService);
  const tokenUrl = route.queryParamMap.get('Token') ?? route.queryParamMap.get('token');

  if (tokenUrl === null) {
    return true;
  }

  try {
    if (isJwtVigente(tokenUrl)) {
      localStorageService.add(ACCESS_TOKEN_PORTAL_KEY, tokenUrl);
    } else {
      localStorageService.removeItem(ACCESS_TOKEN_PORTAL_KEY);
    }
  } catch (erro) {
    console.error(
      'Falha ao atualizar o token do portal no armazenamento local.',
      erro instanceof Error ? erro.message : 'erro desconhecido',
    );
  }

  const urlSemToken = router.parseUrl(state.url);
  delete urlSemToken.queryParams['Token'];
  delete urlSemToken.queryParams['token'];

  return new RedirectCommand(urlSemToken, { replaceUrl: true });
};
